<script>
export default {
  name: 'locationIcon',
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1rem" height="1.1rem" viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
       stroke-width="2.5">
      <circle cx="12" cy="10" r="3"/>
      <!-- eslint-disable-next-line max-len -->
      <path d="M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8"/>
    </g>
  </svg>
</template>

